var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, InputLabel, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { default as MuiSelect } from '@mui/material/Select';
import { debounce } from 'hx-util';
export function Select(_a) {
    var name = _a.name, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, children = _a.children, triggerNext = _a.triggerNext, className = _a.className, required = _a.required, label = _a.label, rules = _a.rules, _c = _a.variant, variant = _c === void 0 ? 'filled' : _c, watcher = _a.watcher, _d = _a.debounceTime, debounceTime = _d === void 0 ? 0 : _d;
    var control = useFormContext().control;
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, ref = _b.ref, value = _b.value, _c = _a.fieldState, invalid = _c.invalid, isTouched = _c.isTouched, isDirty = _c.isDirty, error = _c.error;
            if (!value)
                value = '';
            var handleChange = debounce(function (event) {
                onChange(event);
                // if (triggerNext) handleNext();
                if (watcher)
                    watcher(event);
            }, debounceTime);
            return (_jsxs(FormControl, __assign({ variant: variant, className: className }, { children: [_jsx(InputLabel, __assign({ id: "".concat(name, "-input") }, { children: label })), _jsx(MuiSelect, __assign({ error: !!error, labelId: "".concat(name, "-input"), value: value, onChange: handleChange, required: true }, { children: children })), error && _jsx(FormHelperText, __assign({ error: true }, { children: error.message }))] })));
        } }));
}
export default Select;
